import { IRoute } from '@interfaces/App.interface';

import HomePage from '@pages/HomePage';
import PageAbout from '@pages/AboutPage';
import PageConfig from '@pages/ConfigPanelPage';
import PageHelp from '@pages/HelpPage';
import PageLogin from '@pages/Auth/LoginPage';
import PasswordRecoveryPage from '@pages/Auth/PasswordRecoveryPage';
import LandingPage from '@pages/LandingPage';
import PageRedirectHome from '@pages/RedirectHomePage';

import TemplatePage from '@pages/TemplatePage';

// DASHBOARD
import DashboardPage from '@pages/DashboardPage';
import DashboardRTIMockPage from '@pages/DashboardMock/DashboardRTIMockPage';
import DashboardTimeMockPage from '@pages/DashboardMock/DashboardProductivityMockPage';
import DashboardHSEMockPage from '@pages/DashboardMock/DashboardHSEMockPage';
import DashboardAirportAssetsMockPage from '@pages/DashboardMock/DashboardAirportAssetsMockPage';
import Callback from '@pages/Callback';
import TestPage from '@pages/TestPage';

const isDev = process.env.NODE_ENV === 'development';

//#region Configuration
const appRoutes: IRoute[] = [
  {
    id: 'login',
    matchPath: '/login/(.*)?',
    pageTitle: 'Login',
    pageComponent: PageLogin,
    aclId: '',
  },
  {
    id: 'login',
    matchPath: '/login',
    pageTitle: 'Login',
    pageComponent: PageLogin,
    aclId: '',
  },
  {
    id: 'forgotPassword',
    matchPath: '/forgot_password',
    pageTitle: 'Recover your password',
    pageComponent: PasswordRecoveryPage,
    aclId: '',
  },
  {
    id: 'callback',
    matchPath: 'sso/microsoft/callback/*',
    pageTitle: 'callback',
    pageComponent: Callback,
    aclId: '',
  },
  {
    id: 'home',
    matchPath: '/',
    pageTitle: 'Home',
    pageComponent: HomePage,
    aclId: '',
  },
  {
    id: 'redirectHome',
    matchPath: '/',
    pageTitle: 'Home',
    pageComponent: PageRedirectHome,
    aclId: '',
  },
  {
    id: 'loginHome',
    matchPath: '/login/home',
    pageTitle: 'Home',
    pageComponent: PageRedirectHome,
    aclId: '',
  },
  {
    id: 'home',
    matchPath: '/home',
    pageTitle: 'Home',
    pageComponent: PageRedirectHome,
    aclId: '',
  },
  {
    id: 'reports',
    matchPath: '/reports',
    pageTitle: 'Reports',
    pageComponent: LandingPage,
    aclId: 'taNotification',
    redirectPath: '/welcome',
  },
  {
    id: 'welcome',
    matchPath: '/welcome',
    pageTitle: 'welcome',
    pageComponent: LandingPage,
    aclId: 'taNotification',
  },
  {
    id: 'config',
    matchPath: '/config/:tab?/:page?',
    pageTitle: 'Configuration of operations',
    pageComponent: PageConfig,
    aclId: '',
  },
  {
    id: 'help',
    matchPath: '/help',
    pageTitle: 'Help',
    pageComponent: PageHelp,
    aclId: '',
  },
  {
    id: 'about',
    matchPath: '/about',
    pageTitle: 'About',
    pageComponent: PageAbout,
    aclId: '',
  },

  // DASHBOARD
  {
    id: 'dashboard',
    matchPath: '/dashboard',
    pageTitle: 'Dashboard',
    pageComponent: DashboardPage,
    aclId: '',
  },
  {
    id: 'dashboardRTIMock',
    matchPath: '/mockup/dashboard',
    pageTitle: 'Dashboard',
    pageComponent: DashboardRTIMockPage,
    aclId: '',
  },
  {
    id: 'dashboardRTIMock',
    matchPath: '/mockup/rti/dashboard',
    pageTitle: 'Dashboard',
    pageComponent: DashboardRTIMockPage,
    aclId: '',
  },
  {
    id: 'dashboardTimeMock',
    matchPath: '/mockup/productivity/dashboard',
    pageTitle: 'Productivity Dashboard',
    pageComponent: DashboardTimeMockPage,
    aclId: '',
  },
  {
    id: 'dashboardHSEMock',
    matchPath: '/mockup/hse/dashboard',
    pageTitle: 'HSE Dashboard',
    pageComponent: DashboardHSEMockPage,
    aclId: '',
  },
  {
    id: 'dashboardAirportAssetsMock',
    matchPath: '/mockup/airportassets/dashboard',
    pageTitle: 'Airport Terminal Operations',
    pageComponent: DashboardAirportAssetsMockPage,
    aclId: '',
  },
];

const devOnlyRoutes: IRoute[] = [
  {
    id: 'TemplatePage',
    matchPath: '/testCM',
    pageTitle: 'TemplatePage',
    pageComponent: TemplatePage,
    aclId: '',
  },
  {
    id: 'TemplatePage',
    matchPath: '/testMG',
    pageTitle: 'TemplatePage',
    pageComponent: TestPage,
    aclId: '',
  },
  {
    id: 'TemplatePage',
    matchPath: '/testCM/new',
    pageTitle: 'TemplatePage',
    pageComponent: TemplatePage,
    aclId: '',
  },
];
//#endregion

export default isDev ? [...appRoutes, ...devOnlyRoutes] : [...appRoutes];
